import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';

const getCredentials = async () => {
  try {
    const headers = {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Basic ${process.env.REACT_APP_SENSEDIA_CLIENT_ID}`
    };
    const url = `${process.env.REACT_APP_SENSEDIA_OAUTH_API}/access-token`;

    const response = await axios.post(
      url,
      { grant_type: 'client_credentials' },
      { headers }
    );

    const access_token = response.data.access_token;
    return access_token;
  } catch (error) {
    console.log('Erro ao recuperar o access-token na sensedia: ', error);
  }
};

const api = async () => {
  let access_token;
  if (!access_token) access_token = await getCredentials();

  const axiosConfig: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_API_SENSEDIA_URL + '/consentimentos',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${access_token}`
    }
  };

  return axios.create(axiosConfig);
};

export const getClientConsentInfoByToken = async (token: string) => {
  const apiAceite = await api();
  const response = await apiAceite.get('/consentimento-cliente', {
    headers: { token }
  });
  console.log('data:', response.data);
  return response.data;
};

export const sendQuizAnswers = async (questions: any, quiz_key: string) => {
  const token = sessionStorage.getItem('token') || '';

  if (!quiz_key) {
    return new Error('quiz_key não encontrada');
  }
  console.log({ token, quiz_key });
  const apiAceite = await api();
  const response = await apiAceite.post(
    '/quiz',
    { quiz_key, answers: questions },
    { headers: { token } }
  );
  return response.data;
};

export const getQuizQuestions = async () => {
  const token = sessionStorage.getItem('token') || '';
  const apiAceite = await api();
  const response = await apiAceite.get('/quiz', { headers: { token } });

  return response.data;
};

export const acceptionConsent = async (accepted: boolean) => {
  const token = sessionStorage.getItem('token') || '';
  const apiAceite = await api();
  const response = await apiAceite.post(
    '/aceitacao-termo',
    { accept_terms: accepted },
    { headers: { token } }
  );

  return response.data;
};
